/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerCreateTelegramLinkMutationResponse,
  TelegramUsersControllerCreateTelegramLink401,
} from '../types/TelegramUsersControllerCreateTelegramLink.ts';

function getTelegramUsersCreateTelegramLinkUrl() {
  const res = { method: 'POST', url: `/api/telegram/users/telegram-link` as const };
  return res;
}

/**
 * {@link /api/telegram/users/telegram-link}
 */
export async function telegramUsersCreateTelegramLink(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramUsersControllerCreateTelegramLinkMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerCreateTelegramLink401>,
    unknown
  >({ method: 'POST', url: getTelegramUsersCreateTelegramLinkUrl().url.toString(), ...requestConfig });
  return res.data;
}
